export default __webpack_public_path__ + "static/media/trr-event-mixology.ed55a552.png";